<template>
  <div v-if="data.form">
    <v-tabs
        center-active
        v-model="tab"
        class="tab-digital-menu sticky">
      <v-tab
          class="text-overline"
          v-for="product in data.form.products"
          :key="product.relation_id"
          :href="`#tab-${product.relation_id}`"
      >
        <span v-if="!product.canBeAddedToCart" class="red--text">*</span> {{ product.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
          v-for="formProduct in data.form.products" :id="`tab-${formProduct.relation_id}`" :key="`${formProduct.relation_id}`"
      >
        <v-card flat>
          <configure-product :form="formProduct"
                             @canBeAddedToCart="canBeAddedToCart = $event"
                             :key="`configure-product-${formProduct.relation_id}`"
                             type="combo"/>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import ConfigureProduct from "../ConfigureProduct";
import _ from "lodash";

export default {
  name: "Combo",
  props: {
    data: {
      required: true
    }
  },
  data: () => ({
    tab: null,
    canBeAddedToCart: false
  }),
  components: {
    ConfigureProduct
  },
  setup () {
    const configs = _config.functionalities.digitalmenu.configs
    return { configs }
  },
  mounted () {
    this.initForm()
  },
  methods: {
    initForm () {
      if (!this.data.editing) {
        this.data.form = this.makeProductForm(this.data.form.product)

        this.data.form.products = this.data.form.product.components.map(product => {
          return this.makeProductForm(product)
        })
      }
    },

    makeProductForm (product) {
      let isCombo = product.composition_type === 1
      let formProduct = isCombo ? product : product.component

      let unitaryValue = isCombo ? product.unitary_value : product.value

      return {
        ref: Date.now(),
        name: formProduct.name,
        code: formProduct.code,
        id: formProduct.id,
        relation_id: product.id,
        canBeAddedToCart: isCombo ? false : !(!isCombo && formProduct.attributes),
        tap_flg_item: formProduct.tap_flg_item,
        tap_flg_beer: formProduct.tap_flg_beer,
        flg_separate_print: formProduct.flg_separate_print,
        flg_stock_control: formProduct.flg_stock_control,
        flg_charge_service_fee: formProduct.flg_charge_service_fee,
        discount_value: 0,
        price_list_id: null,
        price_list_product_id: null,
        amount: 1,
        unit_of_measure: formProduct.unit_of_measure,
        unitary_value: parseFloat(unitaryValue),
        total_value: parseFloat(unitaryValue),
        base_value: parseFloat(unitaryValue),
        composition_type: formProduct.composition_type,
        printPoints: formProduct.print_points,
        removedComponents: [],
        observation: [],
        image: formProduct.image,
        product: formProduct,
        plus_additionals_enabled: true,
        tax_value: this.chargeTax ? this.formatValue(unitaryValue * (this.configs.percent_tax / 100)) : 0,
        ...(!isCombo && formProduct.attributes && {attributes: []}),
        ...(!isCombo && formProduct.additionals && {additionals: []}),
        ...(isCombo && {products: null}),
      }
    }
  },
  computed: {
    isCombo() {
      return this.data.form.product.composition_type === 1
    },
    chargeTax () {
      return this.configs.enable_service_tax && this.data.form.product.flg_charge_service_fee
    }
  }
}
</script>

<style scoped>

</style>